webpackJsonp([1],[
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);



var config = {
  apiKey: 'AIzaSyDrv83fRdbIbRC5yYxBJKhCHACP-ld4UFI',
  authDomain: 'app-5pani2pesci.firebaseapp.com',
  databaseURL: 'https://app-5pani2pesci.firebaseio.com',
  storageBucket: 'app-5pani2pesci.appspot.com',
  messagingSenderId: '423190157517'
};
__WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp(config);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_firebase___default.a);

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(0);


__WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* default */];

var store = {
  rootRef: 'members/users/',
  showDialog: false,
  admin: false,
  uid: '',
  user: {},
  members: {}
};

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var locale = {
  today: function today(loc) {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }
    if (loc === 'it') {
      today = dd + '/' + mm + '/' + yyyy;
    } else {
      today = yyyy + mm + dd;
    }
    return today;
  },
  it: {
    months: {
      '01': 'Gennaio',
      '02': 'Febbraio',
      '03': 'Marzo',
      '04': 'Aprile',
      '05': 'Maggio',
      '06': 'Giugno',
      '07': 'Luglio',
      '08': 'Agosto',
      '09': 'Settembre',
      '10': 'Ottobre',
      '11': 'Novembre',
      '12': 'Dicembre'
    },
    monthNumber: function monthNumber(date) {
      var no = date.slice(3, 5);
      return no;
    },
    translate: function translate(name) {
      var itName = name;
      switch (name) {
        case 'submitted':
          itName = 'In attesa';
          break;
        case 'accepted':
          itName = 'Ammesso';
          break;
        case 'active':
          itName = 'In regola';
          break;
        case 'inactive':
          itName = 'Quota associativa scaduta';
          break;
        default:
          itName = name;
      }
      return itName;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (locale);

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(123),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_firebase__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Main__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Login__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Signup__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Signup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Signup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Logout__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Logout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Logout__);











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{ path: '/', name: 'Main', component: __WEBPACK_IMPORTED_MODULE_3__components_Main___default.a, meta: { auth: true } }, { path: '/login', name: 'Login', component: __WEBPACK_IMPORTED_MODULE_4__components_Login___default.a }, { path: '/iscrizione', name: 'Signup', component: __WEBPACK_IMPORTED_MODULE_5__components_Signup___default.a }, { path: '/logout', name: 'Logout', component: __WEBPACK_IMPORTED_MODULE_6__components_Logout___default.a }, { path: '*', redirect: { name: 'Main' } }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach(function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_2__modules_firebase__["a" /* default */].auth().onAuthStateChanged(function (user, error) {
    if (user) {
      __WEBPACK_IMPORTED_MODULE_2__modules_firebase__["a" /* default */].database().ref('members/users/').child(user.uid).once('value', function (snapshot) {
        next();
        if (to.name === 'Login' || to.name === 'Signup') {
          next({ name: 'Main' });
        } else {
          next();
        }
      });
    } else {
      if (to.matched.some(function (record) {
        return record.meta.auth;
      })) {
        next({ name: 'Login' });
      } else {
        next();
      }
    }
  });
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(98)
__webpack_require__(97)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(124),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 44 */,
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_firebase__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_store__ = __webpack_require__(4);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  data: __WEBPACK_IMPORTED_MODULE_5__modules_store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a },
  beforeMount: function beforeMount() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_4__modules_firebase__["a" /* default */].auth().onAuthStateChanged(function (user, error) {
      if (user) {
        _this.uid = user.uid;
        __WEBPACK_IMPORTED_MODULE_4__modules_firebase__["a" /* default */].database().ref('admin/').once('value').then(function (snapshot) {
          if (snapshot.hasChild(user.uid)) {
            _this.admin = true;
          }
        });

        __WEBPACK_IMPORTED_MODULE_4__modules_firebase__["a" /* default */].database().ref('members/users/').child(user.uid).on('value', function (snapshot) {
          _this.user = snapshot.val();
        });
      } else {
        console.log('not logged in');
      }
    });
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_firebase__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_store__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      store: __WEBPACK_IMPORTED_MODULE_1__modules_store__["a" /* default */],
      members: {},
      edit: false,
      search: true,
      search_text: '',
      title: 'Libro soci',
      headers: [{ text: 'Nome e Cognome', value: 'name', left: true }, { text: 'Email', value: 'email' }, { text: 'Cellulare', value: 'mobile' }, { text: 'Città', value: 'city' }, { text: 'Socio', value: 'type' }, { text: 'Quota', value: 'fee' }, { text: 'Accettato', value: 'accepted' }, { text: 'Richiesta', value: 'requested' }, { text: 'Stato', value: 'status' }],
      items: []
    };
  },

  watch: {},
  beforeMount: function beforeMount() {
    var _this = this;

    var items = [];
    __WEBPACK_IMPORTED_MODULE_0__modules_firebase__["a" /* default */].database().ref('members/users/').once('value').then(function (snapshot) {
      var data = snapshot.val();
      for (var kk in data) {
        var member = { value: false };
        for (var pp in data[kk]) {
          member[pp] = data[kk][pp];
        }
        items.push(member);
      }
      _this.items = items;
    });
  }
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_firebase__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_store__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      store: __WEBPACK_IMPORTED_MODULE_1__modules_store__["a" /* default */],
      email: '',
      passw: '',
      error: {
        show: false,
        message: ''
      },
      welcome: 'Welcome back!'
    };
  },

  methods: {
    logIn: function logIn() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__modules_firebase__["a" /* default */].auth().signInWithEmailAndPassword(this.email, this.passw).then(function (m) {
        _this.error.show = false;
        _this.$router.push({ name: 'Main' });
      }).catch(function (e) {
        _this.error.show = true;
        _this.error.message = e.message;
        setTimeout(function () {
          _this.error.show = false;
        }, 3000);
      });
    }
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_firebase__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["default"] = ({
  beforeMount: function beforeMount() {
    __WEBPACK_IMPORTED_MODULE_0__modules_firebase__["a" /* default */].auth().signOut();
    this.$router.push({ name: 'Login' });
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_store__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Toolbar__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Membership__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Membership___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Membership__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Submitted__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Submitted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Submitted__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Administration__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Administration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Administration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Members__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Members___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Members__);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'app-toolbar': __WEBPACK_IMPORTED_MODULE_1__Toolbar___default.a,
    'administration': __WEBPACK_IMPORTED_MODULE_4__Administration___default.a,
    'members': __WEBPACK_IMPORTED_MODULE_5__Members___default.a,
    'membership': __WEBPACK_IMPORTED_MODULE_2__Membership___default.a,
    'submitted': __WEBPACK_IMPORTED_MODULE_3__Submitted___default.a
  },
  data: function data() {
    return {
      status: '',
      admin: false,
      store: __WEBPACK_IMPORTED_MODULE_0__modules_store__["a" /* default */]
    };
  },

  watch: {
    '$route.query': function $routeQuery() {
      if (this.store.user != null) {
        this.status = this.store.user.status;
      }
    },
    'store.user.status': function storeUserStatus() {
      this.status = this.store.user.status;
      console.log('status changed');
    },
    'store.admin': function storeAdmin() {
      this.admin = this.store.admin;
    }
  },
  beforeMount: function beforeMount() {
    this.admin = this.store.admin;

    if (this.store.user != null) {
      this.status = this.store.user.status;
    }
  }
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_firebase__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_store__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_locale__ = __webpack_require__(17);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  props: ['itemData', 'itemRef', 'showDialog'],
  watch: {
    'itemData': function itemData() {
      this.data = this.itemData;

      if (this.data.hasOwnProperty('payments')) {
        if (this.data.payments.hasOwnProperty(this.currentYear)) {
          this.paidCurrentFee = this.data.payments[this.currentYear].date;
        }
      }
    },
    'itemRef': function itemRef() {
      this.ref = this.itemRef;
    },
    'showDialog': function showDialog() {
      this.show = this.showDialog;
    }
  },
  data: function data() {
    return {
      data: {},
      currentYear: '2017',
      paidCurrentFee: 'Non in regola',
      showPayments: false,
      showStatus: false,
      accepted: '',
      pay: {
        fee: '',
        date: '',
        amount: ''
      },
      ref: '',
      show: '',
      store: __WEBPACK_IMPORTED_MODULE_1__modules_store__["a" /* default */],
      snackbar: false,
      removeConfirmation: false,
      message: {
        accepted: 'Ammesso il',
        submitted: 'Non ancora ammesso'
      },
      error: {
        show: false,
        message: 'Name and Email are still empty.'
      },
      payments: {
        '2016': { date: '03/02/2016', amount: '35' },
        '2017': { date: '01/01/2017', amount: '35' }
      }
    };
  },

  computed: {},
  methods: {
    translate: function translate(text) {
      return __WEBPACK_IMPORTED_MODULE_2__modules_locale__["a" /* default */].it.translate(text);
    },
    changeMemberStatus: function changeMemberStatus() {
      __WEBPACK_IMPORTED_MODULE_0__modules_firebase__["a" /* default */].database().ref(this.store.rootRef).child(this.ref).update({
        status: this.data.status,
        accepted: this.data.accepted,
        requested: this.data.requested
      });
      this.showStatus = false;
    },
    addPayment: function addPayment() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__modules_firebase__["a" /* default */].database().ref(this.store.rootRef).child(this.ref).child('payments/').child(this.pay.fee).set({ date: this.pay.date, amount: this.pay.amount }).then(function () {
        if (_this.pay.fee === _this.currentYear && _this.pay.amount !== '') {
          _this.paidCurrentFee = _this.pay.date;
        }
        __WEBPACK_IMPORTED_MODULE_0__modules_firebase__["a" /* default */].database().ref(_this.store.rootRef).child(_this.ref).child('payments/').once('value', function (snapshot) {
          _this.data.payments = snapshot.val();
        });
        _this.showPayments = false;
        _this.pay.fee = '';
        _this.pay.amount = '';
        _this.pay.date = '';
      });
    },
    addPaymentTest: function addPaymentTest() {
      this.payments[this.pay.fee] = { date: this.pay.date, amount: this.pay.amount };
      if (this.pay.fee === this.currentYear && this.pay.amount !== '') {
        this.paidCurrentFee = this.pay.date;
      }
      this.showPayments = false;
      this.pay.fee = '';
      this.pay.amount = '';
      this.pay.date = '';
    },
    close: function close() {
      this.show = false;
      this.store.showDialog = false;
    }
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {}
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_firebase__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_store__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_locale__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Toolbar__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MemberItem__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MemberItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MemberItem__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'toolbar': __WEBPACK_IMPORTED_MODULE_3__Toolbar___default.a,
    'member-item': __WEBPACK_IMPORTED_MODULE_4__MemberItem___default.a
  },
  watch: {
    'showDialog': function showDialog() {
      if (this.showDialog === false) {}
    }
  },
  data: function data() {
    return {
      store: __WEBPACK_IMPORTED_MODULE_1__modules_store__["a" /* default */],
      rootRef: 'members/users/',
      snackbar: false,
      removeConfirmation: false,
      showDialog: false,

      error: {
        show: false,
        message: 'Name and Email are still empty.'
      },
      list: [],
      data: {},
      itemData: {},
      itemRef: ''
    };
  },

  methods: {
    removeStaff: function removeStaff(item) {
      __WEBPACK_IMPORTED_MODULE_0__modules_firebase__["a" /* default */].database().ref('users/').child(this.ref).remove();
      __WEBPACK_IMPORTED_MODULE_0__modules_firebase__["a" /* default */].database().ref(this.rootRef).child(this.ref).remove();
      this.removeConfirmation = false;
      this.showDialog = false;
    },
    show: function show(ref) {
      this.store.showDialog = true;
      this.itemData = this.data[ref];
      this.itemRef = ref;
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    this.$router.push({ name: 'Main', query: { status: 'active' } });

    __WEBPACK_IMPORTED_MODULE_0__modules_firebase__["a" /* default */].database().ref(this.rootRef).orderByChild('requested').on('value', function (snapshot) {
      var data = snapshot.val();
      var list = [];
      snapshot.forEach(function (snap) {
        list.unshift({
          avatar: '',
          name: snap.val().name,
          status: snap.val().status,
          readableStatus: __WEBPACK_IMPORTED_MODULE_2__modules_locale__["a" /* default */].it.translate(snap.val().status),
          email: snap.val().email,
          ref: snap.key
        });
      });
      _this.list = list;
      _this.data = data;
    });
  },
  mounted: function mounted() {}
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_firebase__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_locale__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_store__ = __webpack_require__(4);









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      store: __WEBPACK_IMPORTED_MODULE_4__modules_store__["a" /* default */],

      title: 'Hai quasi finito!',
      subtitle: 'Completa la tua iscrizione inserendo tutte le informazioni',
      submit: 'Invia',
      next: 'Avanti',
      back: 'Indietro',
      loading: false,
      stage: 1,

      member: {
        uid: '',
        personal: {
          name: { data: '', label: 'Nome e Cognome', type: 'text' },
          cf: { data: '', label: 'Codice Fiscale', type: 'text' },
          birthday: { data: '', label: 'Data di nascita (gg/mm/yyyy)', type: 'text' },
          city: { data: '', label: 'Luogo di nascita', type: 'text' }
        },
        address: {
          street: { data: '', label: 'Via', type: 'text' },
          postal: { data: '', label: 'Codice postale', type: 'text' },
          city: { data: '', label: 'Città', type: 'text' },
          mobile: { data: '', label: 'Telefono', type: 'text' }
        },
        accept: {
          ordinary: false,
          statute: false,
          images: false
        }
      },
      error: {
        show: false,
        message: '',
        timeout: 4000
      }
    };
  },

  methods: {
    nextStep: function nextStep(type) {
      var inpData = this.member[type];

      var reqTest = [];
      for (var key in inpData) {
        reqTest.push(!!inpData[key].data);
      }
      var allRequired = reqTest.every(function (kk) {
        return kk;
      });

      if (allRequired) {
        this.stage++;
      } else {
        this.error.message = 'Tutti i campi sono obbligatori';
        this.error.show = true;
      }
    },
    submitMembership: function submitMembership() {
      var _this = this;

      this.loading = true;
      var data = this.member.accept;
      var allRequired = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data).every(function (kk) {
        return data[kk];
      });
      if (allRequired) {
        __WEBPACK_IMPORTED_MODULE_2__modules_firebase__["a" /* default */].auth().onAuthStateChanged(function (user, error) {
          if (user) {
            var member = {
              status: 'submitted',
              requested: __WEBPACK_IMPORTED_MODULE_3__modules_locale__["a" /* default */].today(),
              accepted: '',
              payment: {},
              type: 'ordinario',

              name: _this.member.personal.name.data,
              email: user.email,
              mobile: _this.member.address.mobile.data,

              cf: _this.member.personal.cf.data,
              birthday: _this.member.personal.birthday.data,
              birthcity: _this.member.personal.city.data,

              street: _this.member.address.street.data,
              postal: _this.member.address.postal.data,
              city: _this.member.address.city.data
            };
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              member;

              setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_2__modules_firebase__["a" /* default */].database().ref('members/users/').child(user.uid).update(member);
                resolve();
              }, 1000);
            }).catch(function () {
              console.error('Firebase update error');
            });
          }
        });
      } else {
        this.error.message = 'È obbligatorio accettare tutti i punti';
        this.error.show = true;
        setTimeout(function () {
          _this.loading = false;
        }, 200);
      }
    }
  }
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_firebase__ = __webpack_require__(0);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      welcome: 'Benvenuto!',
      title: 'Benvenuto!',
      subtitle: 'In questa pagina richiedi l\'iscrizione all\'associazione 5pani2pesci in qualità di socio',

      member: {
        contact: {
          email: { data: '', label: 'Email', type: 'text' },
          passw: { data: '', label: 'Password', type: 'password' },
          passwRetype: { data: '', label: 'Riscrivi password', type: 'password' }
        }
      },
      error: {
        show: false,
        message: ''
      }
    };
  },

  methods: {
    signUp: function signUp() {
      var _this = this;

      var reqTest = [];
      var inpData = this.member.contact;
      for (var key in inpData) {
        reqTest.push(!!inpData[key].data);
      }
      var allRequired = reqTest.every(function (kk) {
        return kk;
      });

      if (allRequired) {
        if (inpData.passw.data !== inpData.passwRetype.data) {
          this.error.message = 'Le password non coincidono';
          this.error.show = true;
        } else {
          var email = this.member.contact.email.data;
          var passw = this.member.contact.passw.data;
          __WEBPACK_IMPORTED_MODULE_0__modules_firebase__["a" /* default */].auth().createUserWithEmailAndPassword(email, passw).then(function (user) {
            __WEBPACK_IMPORTED_MODULE_0__modules_firebase__["a" /* default */].database().ref('members/users/').child(user.uid).set({
              email: _this.member.contact.email.data,
              status: 'incomplete' });
            __WEBPACK_IMPORTED_MODULE_0__modules_firebase__["a" /* default */].database().ref('users/').child(user.uid).set({
              email: _this.member.contact.email.data,
              provider: 'email'
            });
          }).catch(function (e) {
            _this.error.show = true;
            if (e.code === 'auth/email-already-in-use') {
              _this.error.message = 'Questa email è già utilizzata da un altro utente';
            }
            if (e.code === 'auth/invalid-email' || e.code === 'auth/argument-error') {
              _this.error.message = 'Email non corretta';
            }
            if (e.code === 'auth/weak-password') {
              _this.error.message = 'La password deve contenere almeno 6 caratteri';
            }
          });
        }
      } else {
        this.error.message = 'Tutti i campi sono obbligatori';
        this.error.show = true;
      }
    }
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      title: 'Grazie!',
      subtitle: 'La tua richiesta è stata accolta',
      text: 'Al prossimo incontro del Consiglio Direttivo, ' + 'riceverai conferma del buon esito della tua iscrizione a 5pani2pesci, ' + 'insieme agli estremi bancari per poter versare la quota associativa.'
    };
  },

  methods: {}
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_firebase__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_store__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  methods: {
    logOut: function logOut() {
      __WEBPACK_IMPORTED_MODULE_0__modules_firebase__["a" /* default */].auth().signOut();
      this.$router.push({ name: 'Login' });
    }
  },
  data: function data() {
    return {
      store: __WEBPACK_IMPORTED_MODULE_1__modules_store__["a" /* default */],
      sidebar: false,
      menu: [{}],
      lists: [{ title: 'In regola', route: { name: 'Main', query: { status: 'active' } }, icon: 'label' }, { title: 'Accettati', route: { name: 'Main', query: { status: 'accepted' } }, icon: 'label' }, { title: 'Richieste', route: { name: 'Main', query: { status: 'submitted' } }, icon: 'label' }, { title: 'Incompleti', route: { name: 'Main', query: { status: 'incomplete' } }, icon: 'label' }, { title: 'Inattivi', route: { name: 'Main', query: { status: 'inactive' } }, icon: 'label' }, { title: 'Tutti', route: { name: 'Main' }, icon: 'label' }],
      people: [{ title: 'Francesco Rao', icon: 'label' }, { title: 'Dario Michelino', icon: 'label' }],
      messages: [{ title: 'Messages', icon: 'label' }]
    };
  }
});

/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 94 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 95 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 96 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 97 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 98 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 99 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(99)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(126),
  /* scopeId */
  "data-v-f0061b16",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(96)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(122),
  /* scopeId */
  "data-v-58bae7bc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(118),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(117),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(51),
  /* template */
  __webpack_require__(121),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(52),
  /* template */
  __webpack_require__(125),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(94)
__webpack_require__(95)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(120),
  /* scopeId */
  "data-v-3fcad526",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(93)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(54),
  /* template */
  __webpack_require__(119),
  /* scopeId */
  "data-v-25ee35a2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(100)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(55),
  /* template */
  __webpack_require__(127),
  /* scopeId */
  "data-v-fa189798",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [(_vm.status === 'incomplete') ? _c('membership') : _vm._e(), _vm._v(" "), (_vm.status === 'submitted') ? _c('submitted') : _vm._e(), _vm._v(" "), (_vm.admin) ? _c('members') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('main', [_c('v-content', [_c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "md6": "md6",
      "xs12": "xs12",
      "offset-md3": "true"
    }
  }, [_c('header', {
    staticClass: "display-3"
  }, [_vm._v(_vm._s(_vm.title) + "\n              "), _c('blockquote', {
    staticClass: "mb-4",
    staticStyle: {
      "border-left": "0px",
      "padding-left": "0rem"
    }
  }, [_c('v-icon', {
    staticClass: "display-1 primary--text pr-2",
    staticStyle: {
      "vertical-align": "bottom"
    }
  }, [_vm._v("people")]), _vm._v("\n                " + _vm._s(_vm.subtitle) + "\n              ")], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.error.timeout,
      "top": true
    },
    model: {
      value: (_vm.error.show),
      callback: function($$v) {
        _vm.error.show = $$v
      },
      expression: "error.show"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.error.message) + "\n                "), _c('v-btn', {
    staticClass: "blue--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.error.show = false
      }
    }
  }, [_vm._v("Chiudi")])], 1), _vm._v(" "), _vm._l((_vm.member.contact), function(m) {
    return _c('v-text-field', {
      key: m.label,
      attrs: {
        "label": m.label,
        "type": m.type
      },
      nativeOn: {
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.signUp($event)
        }
      },
      model: {
        value: (m.data),
        callback: function($$v) {
          m.data = $$v
        },
        expression: "m.data"
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.signUp($event)
      }
    }
  }, [_vm._v("Iscriviti")]), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }, [_vm._v("Hai già un account? "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("Login")])], 1)], 1)], 2)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-container', [_c('v-row', {
    staticClass: "mt-5 pt-5 mb-5"
  }, [_c('v-col', {
    attrs: {
      "md3": "md3"
    }
  }), _vm._v(" "), _c('v-col', {
    staticClass: "mt-2",
    attrs: {
      "md6": "md6",
      "xs12": "xs12"
    }
  }, [_c('div', {
    staticClass: "display-2"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('blockquote', {
    staticStyle: {
      "border-left": "0px",
      "padding-left": "0rem"
    }
  }, [_c('v-icon', {
    staticClass: "display-1 primary--text pr-2",
    staticStyle: {
      "vertical-align": "bottom"
    }
  }, [_vm._v("people")]), _vm._v("\n      " + _vm._s(_vm.subtitle) + "\n    ")], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.error.timeout,
      "top": true
    },
    model: {
      value: (_vm.error.show),
      callback: function($$v) {
        _vm.error.show = $$v
      },
      expression: "error.show"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.error.message) + "\n        "), _c('v-btn', {
    staticClass: "blue--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.error.show = false
      }
    }
  }, [_vm._v("Chiudi")])], 1), _vm._v(" "), _c('v-stepper', {
    staticClass: "text-xs-left",
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.stage),
      callback: function($$v) {
        _vm.stage = $$v
      },
      expression: "stage"
    }
  }, [_c('v-stepper-step', {
    attrs: {
      "step": "1",
      "complete": _vm.stage > 1
    }
  }, [_vm._v("\n      I tuoi dati anagrafici\n    ")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "1"
    }
  }, [_vm._l((_vm.member.personal), function(m) {
    return _c('v-text-field', {
      key: m.label,
      attrs: {
        "label": m.label,
        "type": m.type
      },
      model: {
        value: (m.data),
        callback: function($$v) {
          m.data = $$v
        },
        expression: "m.data"
      }
    })
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.nextStep('personal')
      }
    }
  }, [_vm._v(_vm._s(_vm.next))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.stage--
      }
    }
  }, [_vm._v(_vm._s(_vm.back))])], 2), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "2",
      "complete": _vm.stage > 2
    }
  }, [_vm._v("\n      La tua residenza\n    ")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [_vm._l((_vm.member.address), function(m) {
    return _c('v-text-field', {
      key: m.label,
      attrs: {
        "label": m.label,
        "type": m.type
      },
      model: {
        value: (m.data),
        callback: function($$v) {
          m.data = $$v
        },
        expression: "m.data"
      }
    })
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.nextStep('address')
      }
    }
  }, [_vm._v(_vm._s(_vm.next))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.stage--
      }
    }
  }, [_vm._v(_vm._s(_vm.back))])], 2), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "3"
    }
  }, [_vm._v("\n      Adesione allo statuto\n    ")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "3"
    }
  }, [_c('p', {
    staticClass: "text-xs-left",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v("\n        Dichiaro di aver preso visione dello Statuto dell'Associazione e di accettarlo e rispettarlo in ogni suo punto.")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://drive.google.com/uc?export=download&id=0ByYab0ydL41gbnQ1NWQ0ZmhnaDQ"
    }
  }, [_vm._v("Leggi lo statuto di 5pani2pesci")])]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "ml-3",
    attrs: {
      "primary": "",
      "label": "Accetto"
    },
    model: {
      value: (_vm.member.accept.statute),
      callback: function($$v) {
        _vm.member.accept.statute = $$v
      },
      expression: "member.accept.statute"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-xs-left",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v("\n        Acconsento al trattamento dei dati personali ai sensi dell'art. 13 D.lgs. n. 196/2003")]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "ml-3",
    attrs: {
      "primary": "",
      "label": "Accetto"
    },
    model: {
      value: (_vm.member.accept.ordinary),
      callback: function($$v) {
        _vm.member.accept.ordinary = $$v
      },
      expression: "member.accept.ordinary"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-xs-left",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v("\n        Autorizzo la fotografia e la ripresa della mia immagine ed il suo utilizzo per i fini istituzionali di 5pani2pesci")]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "ml-3",
    attrs: {
      "primary": "",
      "label": "Accetto"
    },
    model: {
      value: (_vm.member.accept.images),
      callback: function($$v) {
        _vm.member.accept.images = $$v
      },
      expression: "member.accept.images"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "primary": "",
      "loading": _vm.loading,
      "disabled": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        _vm.submitMembership()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.submit) + "\n      ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.stage--
      }
    }
  }, [_vm._v(_vm._s(_vm.back))])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "primary mt-0",
    attrs: {
      "height": "200px"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "transition": "v-dialog-bottom-transition",
      "overlay": false
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('v-card', [_c('v-card-row', [_c('v-toolbar', {
    staticClass: "pink"
  }, [_c('v-btn', {
    attrs: {
      "icon": "icon"
    },
    nativeOn: {
      "click": function($event) {
        _vm.close($event)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.data.name))])], 1)], 1), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "margin-top": "-20px"
    }
  }, [_c('v-row', {
    attrs: {
      "row": ""
    }
  }, [_c('v-col', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": ""
    }
  }, [_c('v-subheader', [_vm._v("Associazione")]), _vm._v(" "), _c('v-list-item', [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    staticClass: "indigo--text"
  }, [_vm._v("person")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Tipo di socio")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.data.type))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', {
    staticClass: "indigo--text",
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showStatus = true
      }
    }
  }, [_vm._v("edit")])], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-list-tile', [_c('v-list-tile-action'), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Stato")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.translate(_vm.data.status)))])], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-list-tile', [_c('v-list-tile-action'), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [(_vm.data.accepted !== '') ? _c('span', [_vm._v(_vm._s(_vm.message.accepted) + " " + _vm._s(_vm.data.accepted))]) : _c('span', [_vm._v(_vm._s(_vm.message.submitted))])]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Richiesta il " + _vm._s(_vm.data.requested))])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', [_vm._v("Pagamenti")]), _vm._v(" "), _c('v-list-item', [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    staticClass: "indigo--text"
  }, [_vm._v("payment")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Quota associativa " + _vm._s(_vm.currentYear))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.paidCurrentFee))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', {
    staticClass: "indigo--text",
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showPayments = true
      }
    }
  }, [_vm._v("add_circle")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', [_vm._v("Contatti personali")]), _vm._v(" "), _c('v-list-item', [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    staticClass: "indigo--text"
  }, [_vm._v("phone")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.data.mobile))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Mobile")])], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    staticClass: "indigo--text"
  }, [_vm._v("mail")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.data.email))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Personal")])], 1), _vm._v(" "), _c('v-list-tile-action')], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    staticClass: "indigo--text"
  }, [_vm._v("location_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.data.street))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.data.city) + ", " + _vm._s(_vm.data.postal))])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', [_vm._v("Anagrafica")]), _vm._v(" "), _c('v-list-item', [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    staticClass: "indigo--text"
  }, [_vm._v("person_outline")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.data.cf))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.data.birthday) + ", " + _vm._s(_vm.data.birthcity))])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    model: {
      value: (_vm.error.show),
      callback: function($$v) {
        _vm.error.show = $$v
      },
      expression: "error.show"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.error.message) + "\n  "), _c('v-btn', {
    staticClass: "blue--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.error.show = false
      }
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.removeConfirmation),
      callback: function($$v) {
        _vm.removeConfirmation = $$v
      },
      expression: "removeConfirmation"
    }
  }, [_c('v-card', [_c('v-card-row', [_c('v-card-title', [_vm._v("Remove staff member?")])], 1), _vm._v(" "), _c('v-card-row', {
    attrs: {
      "actions": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.removeConfirmation = false
      }
    }
  }, [_vm._v("Disagree")]), _vm._v(" "), _c('v-btn', {
    staticClass: "red",
    nativeOn: {
      "click": function($event) {
        _vm.removeStaff($event)
      }
    }
  }, [_vm._v("Delete")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.showPayments),
      callback: function($$v) {
        _vm.showPayments = $$v
      },
      expression: "showPayments"
    }
  }, [_c('v-card', [_c('v-card-row', [_c('v-card-title', [_c('strong', [_vm._v("Add payment")])])], 1), _vm._v(" "), _c('v-card-row', [_c('v-card-text', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Anno (quota associativa)"
    },
    model: {
      value: (_vm.pay.fee),
      callback: function($$v) {
        _vm.pay.fee = $$v
      },
      expression: "pay.fee"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Data (gg/mm/aaaa)"
    },
    model: {
      value: (_vm.pay.date),
      callback: function($$v) {
        _vm.pay.date = $$v
      },
      expression: "pay.date"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Euro"
    },
    model: {
      value: (_vm.pay.amount),
      callback: function($$v) {
        _vm.pay.amount = $$v
      },
      expression: "pay.amount"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-row', [_c('v-card-text', _vm._l((_vm.data.payments), function(payment, paymentFee) {
    return _c('div', [_c('strong', [_vm._v(_vm._s(paymentFee))]), _vm._v("   " + _vm._s(payment.date) + "   " + _vm._s(payment.amount) + " €\n        ")])
  }))], 1), _vm._v(" "), _c('v-card-row', {
    attrs: {
      "actions": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showPayments = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "red",
    nativeOn: {
      "click": function($event) {
        _vm.addPayment($event)
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.showStatus),
      callback: function($$v) {
        _vm.showStatus = $$v
      },
      expression: "showStatus"
    }
  }, [_c('v-card', [_c('v-card-row', [_c('v-card-title', [_c('strong', [_vm._v("Change status")])])], 1), _vm._v(" "), _c('v-card-row', [_c('v-card-text', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Active",
      "primary": "",
      "value": "active",
      "light": ""
    },
    model: {
      value: (_vm.data.status),
      callback: function($$v) {
        _vm.data.status = $$v
      },
      expression: "data.status"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Accepted",
      "primary": "",
      "value": "accepted",
      "light": ""
    },
    model: {
      value: (_vm.data.status),
      callback: function($$v) {
        _vm.data.status = $$v
      },
      expression: "data.status"
    }
  }), _vm._v(" "), (_vm.data.status === 'accepted') ? _c('v-text-field', {
    attrs: {
      "label": "Ammissione il (gg/mm/aaaa)"
    },
    model: {
      value: (_vm.data.accepted),
      callback: function($$v) {
        _vm.data.accepted = $$v
      },
      expression: "data.accepted"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.status === 'accepted') ? _c('v-text-field', {
    attrs: {
      "label": "Richiesta il (gg/mm/aaaa)"
    },
    model: {
      value: (_vm.data.requested),
      callback: function($$v) {
        _vm.data.requested = $$v
      },
      expression: "data.requested"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Inactive",
      "primary": "",
      "value": "inactive",
      "light": ""
    },
    model: {
      value: (_vm.data.status),
      callback: function($$v) {
        _vm.data.status = $$v
      },
      expression: "data.status"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Submitted",
      "primary": "",
      "value": "submitted",
      "light": ""
    },
    model: {
      value: (_vm.data.status),
      callback: function($$v) {
        _vm.data.status = $$v
      },
      expression: "data.status"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Incomplete",
      "primary": "",
      "value": "incomplete",
      "light": ""
    },
    model: {
      value: (_vm.data.status),
      callback: function($$v) {
        _vm.data.status = $$v
      },
      expression: "data.status"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-row', {
    attrs: {
      "actions": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showStatus = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "red",
    nativeOn: {
      "click": function($event) {
        _vm.changeMemberStatus($event)
      }
    }
  }, [_vm._v("Change")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('main', [_c('v-content', [_c('v-container', [_c('v-row', [_c('v-col', {
    staticStyle: {
      "margin": "10rem auto"
    },
    attrs: {
      "md6": "md6",
      "xs12": "xs12"
    }
  }, [_c('div', {
    staticClass: "display-3 mb-5"
  }, [_vm._v(_vm._s(_vm.welcome))]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.error.show) ? _c('div', [_c('v-alert', {
    staticClass: "mb-5",
    attrs: {
      "error": "",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.error.message))])], 1) : _vm._e()]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Email"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.logIn($event)
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Password",
      "type": "password"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.logIn($event)
      }
    },
    model: {
      value: (_vm.passw),
      callback: function($$v) {
        _vm.passw = $$v
      },
      expression: "passw"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.logIn($event)
      }
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }, [_vm._v("Non hai ancora un account? "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Signup'
      }
    }
  }, [_vm._v("Iscriviti")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    staticClass: "pink"
  }, [_c('v-toolbar-side-icon', {
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.sidebar = !_vm.sidebar
      }
    }
  }), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.store.title))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("search")])], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": "",
      "origin": "top right"
    }
  }, [_c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "icon": "icon"
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-item', [_c('v-list-tile', {
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-list-tile-title', {
    staticClass: "more_vert item"
  }, [_vm._v("Your Jobs")])], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-list-tile', {
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.logOut()
      }
    }
  }, [_c('v-list-tile-title', {
    staticClass: "more_vert item"
  }, [_vm._v("Logout")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-sidebar', {
    attrs: {
      "drawer": ""
    },
    model: {
      value: (_vm.sidebar),
      callback: function($$v) {
        _vm.sidebar = $$v
      },
      expression: "sidebar"
    }
  }, [_c('v-card', [_c('v-card-row', {
    staticClass: "cyan",
    attrs: {
      "height": "10rem"
    }
  }, [_c('v-card-text', [_c('v-card-title', [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.sidebar = !_vm.sidebar
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', [_vm._l((_vm.lists), function(item) {
    return _c('v-list-item', {
      key: item.title
    }, [_c('v-list-tile', {
      attrs: {
        "avatar": "",
        "router": "",
        "href": item.route
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      class: [item.iconClass]
    }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(item.title)
      }
    })], 1)], 1)
  }), _vm._v(" "), _c('v-divider', {
    attrs: {
      "light": ""
    }
  })], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 125 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('toolbar'), _vm._v(" "), _c('member-item', {
    staticStyle: {
      "position": "fixed",
      "z-index": "100"
    },
    attrs: {
      "item-data": _vm.itemData,
      "item-ref": _vm.itemRef,
      "show-dialog": _vm.store.showDialog
    }
  }), _vm._v(" "), _c('v-container', {
    staticClass: "pa-0 mt-2"
  }, [_c('v-row', {
    attrs: {
      "row": ""
    }
  }, [_c('v-col', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.list), function(item) {
    return (item.status === _vm.$route.query.status || _vm.$route.query.status === undefined) ? [(item.header) ? _c('v-subheader', {
      domProps: {
        "textContent": _vm._s(item.header)
      }
    }) : (item.divider) ? _c('v-divider', {
      attrs: {
        "inset": item.inset
      }
    }) : _c('v-list-item', {
      key: item.name
    }, [_c('v-list-tile', {
      attrs: {
        "avatar": "",
        "ripple": ""
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.show(item.ref)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', {
      domProps: {
        "innerHTML": _vm._s(item.readableStatus)
      }
    })], 1)], 1)], 1)] : _vm._e()
  })], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-card', {}, [_c('v-card-title', {
    staticClass: " pt-5"
  }, [_c('div', {}, [_c('v-icon', {
    staticClass: "primary--text pr-2 pb-1",
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_vm._v("people")]), _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.search) ? _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search_text),
      callback: function($$v) {
        _vm.search_text = $$v
      },
      expression: "search_text"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "search": _vm.search_text,
      "select-all": _vm.edit,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([
      ["items", function(props) {
        return [(_vm.edit) ? _c('td', [_c('v-checkbox', {
          attrs: {
            "hide-details": "",
            "primary": ""
          },
          model: {
            value: (props.item.value),
            callback: function($$v) {
              props.item.value = $$v
            },
            expression: "props.item.value"
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.email))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.mobile))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.city))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.type))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.fee))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.accepted))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.requested))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.status))])]
      }]
    ]),
    model: {
      value: (_vm.items),
      callback: function($$v) {
        _vm.items = $$v
      },
      expression: "items"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-container', [_c('v-row', {
    staticClass: "mt-5 pt-5 mb-5"
  }, [_c('v-col', {
    attrs: {
      "md3": "md3"
    }
  }), _vm._v(" "), _c('v-col', {
    staticClass: "mt-2",
    attrs: {
      "md6": "md6",
      "xs12": "xs12"
    }
  }, [_c('div', {
    staticClass: "display-2"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('blockquote', {
    staticStyle: {
      "border-left": "0px",
      "padding-left": "0rem"
    }
  }, [_c('v-icon', {
    staticClass: "display-1 primary--text pr-2",
    staticStyle: {
      "vertical-align": "bottom"
    }
  }, [_vm._v("people")]), _vm._v("\n      " + _vm._s(_vm.subtitle) + "\n    ")], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.text))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })
],[45]);


// WEBPACK FOOTER //
// static/js/app.bef4bb1fa79e8020c296.js